/*
 * taskpane.js — Logique du panneau de configuration
 * ============================================================================
 * - Charge les valeurs existantes depuis Office.context.roamingSettings
 * - Sauvegarde clientId + webhookUrl
 * - Bouton "Tester la connexion" : envoie un payload de test au webhook
 */

const DEFAULT_WEBHOOK_URL = "https://n8n.fdwebpro.be/webhook/pack5-mail-bce";
const TEST_TIMEOUT_MS = 10000;

/* eslint-disable-next-line no-undef */
Office.onReady((info) => {
  if (info.host !== Office.HostType.Outlook) {
    setStatus("warning", "Cet add-in fonctionne uniquement dans Outlook.");
    return;
  }

  bindEvents();
  loadConfig();
});

/* ---------------------------------------------------------------------------
 * DOM helpers
 * ------------------------------------------------------------------------- */
function $(id) {
  return document.getElementById(id);
}

function bindEvents() {
  $("config-form").addEventListener("submit", onSave);
  $("btn-test").addEventListener("click", onTest);
}

/* ---------------------------------------------------------------------------
 * Chargement / sauvegarde de la config
 * ------------------------------------------------------------------------- */
function loadConfig() {
  const settings = Office.context.roamingSettings;
  $("clientId").value = settings.get("clientId") || "";
  $("webhookUrl").value = settings.get("webhookUrl") || DEFAULT_WEBHOOK_URL;
}

function onSave(event) {
  event.preventDefault();

  const clientId = $("clientId").value.trim();
  const webhookUrl = $("webhookUrl").value.trim();

  if (!clientId) {
    setStatus("error", "Le Client ID est obligatoire.");
    return;
  }

  if (!isValidUrl(webhookUrl)) {
    setStatus("error", "L'adresse du webhook n'est pas une URL valide.");
    return;
  }

  if (!webhookUrl.startsWith("https://")) {
    setStatus("error", "Le webhook doit utiliser HTTPS.");
    return;
  }

  const settings = Office.context.roamingSettings;
  settings.set("clientId", clientId);
  settings.set("webhookUrl", webhookUrl);

  setLoading(true);

  settings.saveAsync((result) => {
    setLoading(false);
    if (result.status === Office.AsyncResultStatus.Succeeded) {
      setStatus("success", "Configuration sauvegardée.");
    } else {
      const msg = result.error ? result.error.message : "erreur inconnue";
      setStatus("error", `Erreur lors de la sauvegarde : ${msg}`);
    }
  });
}

/* ---------------------------------------------------------------------------
 * Test de connexion au webhook
 * ------------------------------------------------------------------------- */
async function onTest() {
  const clientId = $("clientId").value.trim();
  const webhookUrl = $("webhookUrl").value.trim();

  if (!clientId) {
    setStatus("error", "Saisissez d'abord un Client ID.");
    return;
  }

  if (!isValidUrl(webhookUrl)) {
    setStatus("error", "L'adresse du webhook n'est pas une URL valide.");
    return;
  }

  setStatus("info", "Test en cours...");
  setLoading(true);

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TEST_TIMEOUT_MS);

  try {
    const response = await fetch(webhookUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Pack5-Client-Id": clientId,
        "X-Pack5-Source": "outlook-addin-v1-test"
      },
      body: JSON.stringify({
        test: true,
        from: "test@fdweb.be",
        subject: "[TEST] Test de connexion FDWeb Pack 5",
        body: "Ceci est un test de connexion depuis l'add-in Outlook.",
        timestamp: new Date().toISOString()
      }),
      signal: controller.signal
    });

    clearTimeout(timer);

    if (response.ok) {
      setStatus("success", `Connexion OK (HTTP ${response.status}). N'oubliez pas de sauvegarder.`);
    } else if (response.status >= 400 && response.status < 500) {
      setStatus(
        "error",
        `Webhook joignable mais a refusé la requête (HTTP ${response.status}). Vérifiez votre Client ID.`
      );
    } else {
      setStatus(
        "error",
        `Webhook a répondu avec une erreur serveur (HTTP ${response.status}).`
      );
    }
  } catch (err) {
    clearTimeout(timer);
    if (err && err.name === "AbortError") {
      setStatus("error", "Délai d'attente dépassé — vérifiez l'URL et votre connexion.");
    } else {
      const msg = (err && err.message) ? err.message : "erreur réseau";
      setStatus("error", `Impossible de joindre le webhook : ${msg}`);
    }
  } finally {
    setLoading(false);
  }
}

/* ---------------------------------------------------------------------------
 * UI helpers
 * ------------------------------------------------------------------------- */
function setStatus(level, message) {
  const el = $("status");
  el.className = `status is-visible is-${level}`;
  el.textContent = message;
}

function setLoading(isLoading) {
  $("btn-test").disabled = isLoading;
  $("btn-save").disabled = isLoading;
}

function isValidUrl(value) {
  try {
    const u = new URL(value);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}
